import { useMutation } from "react-query";
import { addProducerCode } from "../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";

const useAddProdCode = () => {
  return useMutation(addProducerCode);
};

export default useAddProdCode;
